export const environment = {
	production: true,
	//api: 'http://localhost/SOA/factor_ccc_soa/2765_soa_local/rest_api/api'
	//api:'http://localhost/acs_ccc-soa-v2/rest_api/api'
	api: 'https://factor-ccc-soa.mybizpad.com/rest_api/api'
	// api: 'http://localhost/SOA7server/Factor_ccc_soa/2765_soa_local/rest_api/api'
};
